

import colors from "common/theme/foundations/colors";
import { constant } from "common/constant";

  
  export const offerLetterData = [
      {
        id:1,
        offer:'Offer-5',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-03-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:2,
        offer:'Offer-6',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-04-2025"
      },
      {
        id:3,
        offer:'Offer-7',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:4,
        offer:'Offer-8',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:5,
        offer:'Offer-9',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:6,
        offer:'Offer-9',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:7,
        offer:'Offer-9',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:8,
        offer:'Offer-9',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:9,
        offer:'Offer-9',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
      {
        id:10,
        offer:'Offer-9',
        job:"Software Developer",
        jobApplicant:"Job Applicant",
        addedBy:" Martina Nikolaus",
        offerExpireOn:"31-01-2025",
        expectedJoiningDate:"31-01-2025"
      },
    ]
export const jobData = [
  {
    id:1,
    title:"Software Developer"
  },
  {
    id:2,
    title:"Software Tester"
  },
  {
    id:3,
    title:"designer"
  },
  {
    id:4,
    title:"UI/UX developer"
  },
  
]
export const jobApplicant = [
  {
    id:1,
    name:"Keanu Bailey Sr."
  },
  {
    id:2,
    name:"Keanu Bailey Sr."
  },
  {
    id:3,
    name:"Keanu Bailey Sr."
  },
  {
    id:4,
    name:"Keanu Bailey Sr."
  },
  {
    id:5,
    name:"Keanu Bailey Sr."
  }
]
export const rateData = [
  {
    id:1,
    title:"7"
  },
  {
    id:2,
    title:"7"
  },
  {
    id:3,
    title:"7"
  },
  {
    id:4,
    title:"7"
  },
  {
    id:5,
    title:"7"
  }
]
const statusOptions = [
  { label: constant.pending, value: constant.pending, color: colors.yellow[400] },
  { label: constant.withdraw, value: constant.withdraw, color: colors.blue[400] },
  { label: constant.accept, value: constant.accept, color: colors.green[400] },
  { label: constant.expired, value: constant.expired, color: colors.black[400] },
  { label: constant.decline, value: constant.decline, color: colors.red[400] },
  { label: constant.draft, value: constant.draft, color: colors.gray[700] }, 
];

export default statusOptions;
